// extracted by mini-css-extract-plugin
export default {"box":"TestimonialItem_box__ZLfQR","author":"TestimonialItem_author__Tswlo","authorName":"TestimonialItem_authorName__p0qSU"};